// https://github.com/cyntler/react-doc-viewer/tree/main#overriding-loading-renderer

import { OverrideComponent } from "./definitions";

export const LoadingRenderer: OverrideComponent = () => (
  <div className="spinner spinner-primary spinner-lg m-auto" />
);

export default LoadingRenderer;
